function unveil (selectorOrNodelist, threshold = 0, isCapturing = false, scrollContainer) {

	if (
		!selectorOrNodelist
		|| selectorOrNodelist?.length === 0
		|| (typeof selectorOrNodelist !== 'string' && !(selectorOrNodelist instanceof NodeList))
	) {

		return;

	}

	// Convert selectorOrNodelist to an array of images
	const images = typeof selectorOrNodelist === 'string'
		? [ ...document.querySelectorAll(selectorOrNodelist) ]
		: [ ...selectorOrNodelist ];

	if (images.length === 0) return;

	const attrRetina = 'data-src-retina';
	const attrDefault = 'data-src';
	const attr = window.devicePixelRatio > 1 ? attrRetina : attrDefault;

	const observerOptions = {
		root: scrollContainer || null,
		rootMargin: `${threshold}px`,
		threshold: 0
	};

	const onIntersection = (entries, observer) => {

		entries.forEach((entry) => {

			if (entry.isIntersecting) {

				const image = entry.target;
				const imgSrc = image.getAttribute(attr) || image.getAttribute(attrDefault);

				image.classList.remove('notInView');

				if (imgSrc) {

					const onLoadOrError = (e) => {

						const img = e.target;
						img.classList.add('unveil--done');
						img.removeEventListener('load', onLoadOrError);
						img.removeEventListener('error', onLoadOrError);

					};

					image.addEventListener('load', onLoadOrError);
					image.addEventListener('error', onLoadOrError);
					image.setAttribute('src', imgSrc);
					image.removeAttribute(attrDefault);
					image.removeAttribute(attrRetina);

				}

				// Stop observing the image once it's loaded
				observer.unobserve(image);

			}

		});

	};

	const observer = new IntersectionObserver(onIntersection, observerOptions);

	images.forEach((image) => {

		// do not show animated skeleton UI for images that are not visible in viewport
		// to prevent unnecessary browser repaint
		image.classList.add('notInView');

		observer.observe(image);

	});

	return [
		() => {

			observer.disconnect();

		}
	];

}

export default unveil;
